import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import infinityERP from "../../../assets/images/landing/features/mockuper5.png";
import infinityERPLogo from "../../../assets/images/landing/InfinityERP.png";
import infinityXLogo from "../../../assets/images/landing/InfinityX.png";
import infinityFleet from "../../../assets/images/landing/features/mockuper3.png";
import infinityX from "../../../assets/images/landing/features/mockuper2.png";
import { UncontrolledTooltip } from 'reactstrap';
import img5 from "../../../assets/images/companies/img-5.png";
import img2 from "../../../assets/images/companies/img-2.png";
import img7 from "../../../assets/images/companies/img-7.png";
import img8 from "../../../assets/images/companies/img-8.png";
import img1 from "./../../../assets/images/landing/erp0.png";

// Import Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

const Products = () => {
    const [plan, setPlan] = useState(true);
    const toggle = () => setPlan(!plan);

    return (
        <React.Fragment>
            <section className="section bg-light " id="industries">
                <div className="bg-overlay bg-overlay-pattern"></div>
                <Container>
                    {/* First Row: Image on the left */}
                    <Row className="align-items-center gy-4">
                        <Col className="col-lg-6 order-1 order-lg-1">
                            <Swiper
                                modules={[Navigation, Pagination]}
                                spaceBetween={10}
                                slidesPerView={1}
                                navigation
                                loop={true}
                                pagination={{ clickable: true }}
                                style={{ width: '100%', height: 'auto' }}
                            >
                                <SwiperSlide>
                                    <img src={infinityERP} alt="Infinity ERP" style={{ width: '100%', height: 'auto' }} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={infinityX} alt="Another Image" style={{ width: '100%', height: 'auto' }} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={infinityFleet} alt="Third Image" style={{ width: '100%', height: 'auto' }} />
                                </SwiperSlide>
                            </Swiper>
                        </Col>
                        <Col className="col-lg-6 order-2 order-lg-2">
                            <div className="text-muted mt-5 mt-lg-0">
                                <h1 className="mb-3 ff-secondary fw-bold text-capitalize lh-base">
                                    <img
                                        src={infinityERPLogo}
                                        alt=""
                                        style={{ maxWidth: "50%", height: "auto", verticalAlign: "middle" }}
                                    />
                                </h1>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Verticals we cater.</h3>
                                        <p>
                                            <b>We are Omnipresent!</b> Let's find out if we are of help to you.
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Features of ERP</h3>
                                        <p>
                                            <b>What makes us different?</b> Click to know more.
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <Link to="index.html" className="btn btn-primary">
                                        Learn More{" "}
                                        <i className="ri-arrow-right-line align-middle ms-1"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Second Row: Image on the right */}
                    <Row className="align-items-center gy-4">
                        <Col className="col-lg-6 order-1 order-lg-2"><Swiper
                            modules={[Navigation, Pagination]}
                            spaceBetween={10}
                            slidesPerView={1}
                            navigation
                            loop={true}
                            pagination={{ clickable: true }}
                            style={{ width: '100%', height: 'auto' }}
                        >
                            <SwiperSlide>
                                <img src={infinityERP} alt="Infinity ERP" style={{ width: '100%', height: 'auto' }} />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src={infinityX} alt="Another Image" style={{ width: '100%', height: 'auto' }} />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src={infinityFleet} alt="Third Image" style={{ width: '100%', height: 'auto' }} />
                            </SwiperSlide>
                        </Swiper>
                        </Col>
                        <Col className="col-lg-6 order-2 order-lg-1">
                            <div className="text-muted mt-5 mt-lg-0">
                                <h1 className="mb-3 ff-secondary fw-bold text-capitalize lh-base">
                                    <img
                                        src={infinityXLogo}
                                        alt=""
                                        style={{ maxWidth: "50%", height: "auto", verticalAlign: "middle" }}
                                    />
                                </h1>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <p>
                                            ERP on mobile! A mobile solution integrated into line with Infinity ERP for smooth functioning and management of enterprise.
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Many Features</h3>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                    </div>
                                </div>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Easy to use</h3>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <Link to="index.html" className="btn btn-primary">
                                        Learn More{" "}
                                        <i className="ri-arrow-right-line align-middle ms-1"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    {/* First Row: Image on the left */}
                    <Row className="align-items-center gy-4">
                        <Col className="col-lg-6 order-1 order-lg-1">
                            <Swiper
                                modules={[Navigation, Pagination]}
                                spaceBetween={10}
                                slidesPerView={1}
                                navigation
                                loop={true}
                                pagination={{ clickable: true }}
                                style={{ width: '100%', height: 'auto' }}
                            >
                                <SwiperSlide>
                                    <img src={infinityERP} alt="Infinity ERP" style={{ width: '100%', height: 'auto' }} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={infinityX} alt="Another Image" style={{ width: '100%', height: 'auto' }} />
                                </SwiperSlide>
                                <SwiperSlide>
                                    <img src={infinityFleet} alt="Third Image" style={{ width: '100%', height: 'auto' }} />
                                </SwiperSlide>
                            </Swiper>
                        </Col>
                        <Col className="col-lg-6 order-2 order-lg-2">
                            <div className="text-muted mt-5 mt-lg-0">
                                <h1 className="mb-3 ff-secondary fw-bold text-capitalize lh-base">
                                    <img
                                        src={infinityERPLogo}
                                        alt=""
                                        style={{ maxWidth: "50%", height: "auto", verticalAlign: "middle" }}
                                    />
                                </h1>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Verticals we cater.</h3>
                                        <p>
                                            <b>We are Omnipresent!</b> Let's find out if we are of help to you.
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Features of ERP</h3>
                                        <p>
                                            <b>What makes us different?</b> Click to know more.
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <Link to="index.html" className="btn btn-primary">
                                        Learn More{" "}
                                        <i className="ri-arrow-right-line align-middle ms-1"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    {/* Second Row: Image on the right */}
                    <Row className="align-items-center gy-4">
                        <Col className="col-lg-6 order-1 order-lg-2"><Swiper
                            modules={[Navigation, Pagination]}
                            spaceBetween={10}
                            slidesPerView={1}
                            navigation
                            loop={true}
                            pagination={{ clickable: true }}
                            style={{ width: '100%', height: 'auto' }}
                        >
                            <SwiperSlide>
                                <img src={infinityERP} alt="Infinity ERP" style={{ width: '100%', height: 'auto' }} />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src={infinityX} alt="Another Image" style={{ width: '100%', height: 'auto' }} />
                            </SwiperSlide>
                            <SwiperSlide>
                                <img src={infinityFleet} alt="Third Image" style={{ width: '100%', height: 'auto' }} />
                            </SwiperSlide>
                        </Swiper>
                        </Col>
                        <Col className="col-lg-6 order-2 order-lg-1">
                            <div className="text-muted mt-5 mt-lg-0">
                                <h1 className="mb-3 ff-secondary fw-bold text-capitalize lh-base">
                                    <img
                                        src={infinityXLogo}
                                        alt=""
                                        style={{ maxWidth: "50%", height: "auto", verticalAlign: "middle" }}
                                    />
                                </h1>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <p>
                                            ERP on mobile! A mobile solution integrated into line with Infinity ERP for smooth functioning and management of enterprise.
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Many Features</h3>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                    </div>
                                </div>
                                <div className="d-flex feature-v1">
                                    <span className="wrap-icon icon-users"></span>
                                    <div>
                                        <h3>Easy to use</h3>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <Link to="index.html" className="btn btn-primary">
                                        Learn More{" "}
                                        <i className="ri-arrow-right-line align-middle ms-1"></i>
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Products;
